import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import Home from './component/Home'
import ConfirmRelation from './component/ConfirmRelation'
import ConfirmProLink from './component/ConfirmProLink'
import ConfirmOrder from './component/ConfirmOrder'

import Footer from './containers/Footer'
import Header from './containers/Header'

const App = () => {
  return (
    <Router>
        <div>
          <Header/>
          <div className="content">
            <Route exact path="/" component={Home}/>
            <Route path="/confirm-relation" component={ConfirmRelation}/>
            <Route path="/confirm-pro-link/:hash" component={ConfirmProLink}/>
            <Route path="/pro/:hash" component={ConfirmProLink}/>
            <Route path="/order/:hash" component={ConfirmOrder}/>
          </div>
          <Footer/>
        </div>
    </Router>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App/index.js